export const getUnassignedFilters = (state) => ({
  ...state.jobs.filters.unassigned,
  ...state.common.filters,
});

export const getAssignedFilters = (state) => ({
  ...state.jobs.filters.assigned,
  ...state.common.filters,
});

export const getFinishedFilters = (state) => ({
  ...state.jobs.filters.finished,
  ...state.common.filters,
});
